import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import createPersistedState from "vuex-persistedstate";
import { UserModule } from "./modules/userModule";

Vue.use(Vuex);

const persistedModules = ["UserModule"];

const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            paths: persistedModules,
            setState: (key, state: any, storage) => {
                // console.log("store.setState");
                if (key === "vuex") {
                    if (state && state.UserModule && state.UserModule.user && state.UserModule.user.firebaseUser) {
                        const removeFirebase = Object.assign({}, state);
                        delete removeFirebase.UserModule.user.firebaseUser;
                        return storage.setItem(key, JSON.stringify(removeFirebase));
                    }
                }
                return storage.setItem(key, JSON.stringify(state));
            },
        }),
    ],
    modules: {
        UserModule,
    },
});
export { store };
// # sourceMappingURL=store.js.map
